import * as React from 'react'
import { useCallback, useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import Card from '../card/Card'
import CardHeader from '../card/CardHeader'
import CardBody from '../card/CardBody'
import CustomInput from '../input/CustomInput'
import { timeout, UserContext } from '../../App'
import styles from 'assets/jss/dorm-app/views/individualTenantPageStyle.js'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import CustomDateInput from '../input/CustomDateInput'
import Badge from '../badge/Badge'
import Container from '@material-ui/core/Container'
import Button from '../button/RegularButton'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { formatDatesInObject } from '../utils/DateUtils'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

const initialTenantState = {
  name: '',
  surname: '',
  email: '',
  telNumber: '',
  birthday: null,
  gender: '',
  nationality: '',
  university: '',
  studyField: '',
  room: '',
  floor: '',
  movedIn: null,
  movedOut: null,
  tenantId: '',
  currentPoints: '',
  deposit: '',
  extension: '',
  extensionStatus: '',
  sublet: '',
}
const initialPasswordState = {
  oldPassword: '',
  newPassword: '',
}

export default function IndividualTenantPage() {
  const classes = useStyles()

  const [tenant, setTenant] = useState(initialTenantState)
  const [password, setPassword] = useState(initialPasswordState)
  const [proceeding, setProceeding] = useState(true)

  const [notification, setNotification] = useState(initialNotificationState)

  const { user } = useContext(UserContext)

  const changePassword = (e) => {
    e.preventDefault()

    getApiUrl()
      .post(`/individual/password`, password)
      .then(function() {
        setPassword(initialPasswordState)
        setNotification({
          open: true,
          message: 'Passwort geändert',
          color: 'success',
        })
      })
      .catch(function(error) {
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const fetchTenant = useCallback(() => {
    getApiUrl()
      .get(`/individual/tenants/${user.id}`)
      .then(function(response) {
        setProceeding(false)
        setTenant(formatDatesInObject(response.data))
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [user])

  useEffect(() => {
    setProceeding(true)
    fetchTenant()
  }, [fetchTenant])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Meine Daten</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Vorname"
                    id="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.name,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Nachname"
                    id="surname"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.surname,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.email,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Telefonnummer"
                    id="telNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.telNumber,
                      type: 'text',
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Geschlecht"
                    id="gender"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.gender,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomDateInput
                    labelText="Geburt"
                    id="birthday"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.birthday,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Staatsangehörigkeit"
                    id="nationality"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.nationality,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Studienfach"
                    id="studyField"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.studyField,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Universität"
                    id="university"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.university,
                      type: 'text',
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Kaution"
                    id="deposit"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.deposit,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Zimmer"
                    id="room"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.room,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Flur"
                    id="floor"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.floor,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomDateInput
                    labelText="Einzug"
                    id="movedIn"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.movedIn,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomDateInput
                    labelText="Auszug"
                    id="movedOut"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.movedOut,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Aktueller Punktestand"
                    id="currentPoints"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.currentPoints,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Verlängerungen"
                    id="extension"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.extension,
                      type: 'text',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Untermiete (max. 12 Monate)"
                    id="sublet"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenant.sublet,
                      type: 'text',
                    }}
                  />
                </GridItem>
                {tenant.extensionStatus === 'PROCESSING' ? (
                  <GridItem xs={12} sm={12} md={3}>
                    <div style={{ margin: '35px 0 0 70px' }}>
                      <Badge color="info">Verlängerungsbewerbung gestellt</Badge>
                    </div>
                  </GridItem>
                ) : null}
                {tenant.extensionStatus === 'CREATED' ? (
                  <GridItem xs={12} sm={12} md={3}>
                    <div style={{ margin: '35px 0 0 70px' }}>
                      <Badge color="warning">Verlängerungsbewerbung offen</Badge>
                    </div>
                  </GridItem>
                ) : null}
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <br/>
                  <h4>
                    Bei Änderungswünschen schreibe bitte eine Mail an{' '}
                    <a href={'mailto:verwaltung@schollheim.net?subject=Datenänderung SmartDorm'}>
                      {' '}
                      verwaltung@schollheim.net
                    </a>{' '}
                    mit dem Betreff "Datenänderung SmartDorm".
                  </h4>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Passwortänderung</h4>
            </CardHeader>
            <CardBody>
              <Container component="main" maxWidth="xs">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Altes Passwort"
                      id="oldPassword"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: password.oldPassword,
                        type: 'text',
                        onChange: (e) => setPassword({ ...password, oldPassword: e.currentTarget.value }),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Neues Passwort"
                      id="newPassword"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: password.newPassword,
                        type: 'text',
                        onChange: (e) => setPassword({ ...password, newPassword: e.currentTarget.value }),
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <br/>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button
                      color="primary"
                      block
                      onClick={(e) => {
                        changePassword(e)
                      }}>
                      Ändern
                    </Button>
                  </GridItem>
                </GridContainer>
                <Snackbar
                  place="br"
                  color={notification.color}
                  icon={AddAlert}
                  message={notification.message}
                  open={notification.open}
                  closeNotification={() =>
                    setNotification({
                      open: false,
                      message: '',
                      color: '',
                    })
                  }
                  close
                />
              </Container>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  )
}
